import script from "./CartBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartBtn.vue?vue&type=script&lang=ts&setup=true"

import "./CartBtn.vue?vue&type=style&index=0&id=296fd47c&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-296fd47c"]])

export default __exports__